import React from 'react'
import IDonor from '@interfaces/IDonor'
import DonorCardBase from './DonorCardBase'

interface CheckoutDonorCardProps {
  donor: IDonor
  position: number
  selectedTreatment: string
  onRemove?: (id: string) => void
  isDraggable?: boolean
  isLast?: boolean
  showPhotoMatchColumn?: boolean
  isPhotoMatchEligible?: boolean
}

const CheckoutDonorCard: React.FC<CheckoutDonorCardProps> = ({
  donor,
  position,
  selectedTreatment,
  onRemove,
  isDraggable,
  isLast,
  showPhotoMatchColumn,
  isPhotoMatchEligible,
}) => {
  return (
    <DonorCardBase
      donor={donor}
      position={position}
      variant="checkout"
      treatmentDisplayMode="selected-only"
      selectedTreatment={selectedTreatment}
      isDraggable={isDraggable}
      isLast={isLast}
      showPhotoMatchColumn={showPhotoMatchColumn}
      isPhotoMatchEligible={isPhotoMatchEligible}
      onRemove={onRemove}
    />
  )
}

export default CheckoutDonorCard
